import { jsx as e } from "react/jsx-runtime";
import { Stack as d } from "@mui/material";
const n = (o) => {
  const { children: t } = o;
  return /* @__PURE__ */ e(
    d,
    {
      gap: 2,
      padding: 3,
      flexGrow: 1,
      ...o,
      sx: {
        overflowY: "auto",
        overflowX: "hidden",
        borderBottomWidth: 1,
        borderBottomStyle: "solid",
        borderBottomColor: (r) => r.palette.divider,
        ...o.sx || {}
      },
      children: t
    }
  );
};
export {
  n as DrawerContent
};
//# sourceMappingURL=index33.mjs.map
